import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { HttpClient } from '@angular/common/http';
import { ArmaServConnection } from 'src/app/classes/info-connection';
import { ArmaDate, CUtilit } from 'src/app/classes/utilit';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatPaginator } from '@angular/material/paginator';

@Component({
  selector: 'app-event-observer',
  templateUrl: './event-observer.component.html',
  styleUrls: ['./event-observer.component.css']
})
export class EventObserverComponent implements OnInit {

  @ViewChild('MatPaginator', {static: true}) mPaginator!: MatPaginator;

  mDataSource: MatTableDataSource<ArmaSpy>;
  mTableHeader = ['Action', 'Object', 'Code', 'ComputerName', 'ArmaorUserName', 'UnixDate', 'FileStr', ];
  mListObject: string[] = [];
  mListAction: string[] = [];
  mSelectedObject: string | undefined = undefined;
  mSelectedAction: string | undefined = undefined;

  mIsLoading: boolean;
  mIsSelectLoading: boolean = false;    // Use to fill selector with armaspy object and action
  mBeginDate: Date;
  mEndDate: Date;

  constructor(
    private mHttp: HttpClient
  ) {
    this.mBeginDate = CUtilit.getFirstDayOfTheDate();
    this.mEndDate = CUtilit.getLastDayOfTheDate();
    this.mIsLoading = false;
    this.mDataSource = new MatTableDataSource<ArmaSpy>([]); // Init empty table
    this.mDataSource.filterPredicate = (data: ArmaSpy, filter: any) => {
      let addElem = true;
      if (addElem && this.mSelectedAction)
        addElem = (data.Action == this.mSelectedAction);
      if (addElem && this.mSelectedObject)
        addElem = (data.ObjectSpy == this.mSelectedObject);
      return addElem;
    };
  }

  ngOnInit(): void {
    this.mDataSource.paginator = this.mPaginator;
    this.loadTable();
  }

  async loadTable() {
    function unix(date: Date) { return ArmaDate.createFromDate(date).toUnixTimestamp(); }
    this.mIsLoading = true;
    try {
      const dataTemp: ArmaSpy[] = (await ArmaServConnection.aGET(this.mHttp, 'LoadSpy', [unix(this.mBeginDate), unix(this.mEndDate)])).result[0];
      this.fillSelect(dataTemp);
      this.mDataSource.data = dataTemp;
    } finally {
      this.mIsLoading = false;
    }
  }

  async fillSelect(spys: ArmaSpy[]) {
    const newObject = [];
    const newAction = [];
    this.mIsSelectLoading = true;
    try {
      for (let i = 0; i < spys.length; i++) {
        const CurrentSpy = spys[i];
        if (newObject.length == 0) {
          newObject.push(CurrentSpy.ObjectSpy);
          newAction.push(CurrentSpy.Action);
          continue;
        }

        // On tente d'ajouter l'object et l'action
        let addObject = true;
        let addAction = true;
        for (let j = 0; j < newObject.length; j++) {
          if (newObject[j] == CurrentSpy.ObjectSpy)
            addObject = false;
          if (newAction[j] == CurrentSpy.Action)
            addAction = false;
          if (!addObject && !addAction)
            break;
        }
        if (addAction) newAction.push(CurrentSpy.Action);
        if (addObject) newObject.push(CurrentSpy.ObjectSpy);

      }
    } finally {
      this.mListObject = newObject;
      this.mListAction = newAction;
      this.mIsSelectLoading = false;
    }
  }

  onDateChange(dateChange: MatDatepickerInputEvent<any>) {
    this.loadTable();
  }

  updateFilter() {
    this.mDataSource.filter = new Date().toString();
  }

  toDateJS(unixDate: number): string {
    let result = '';
    if (unixDate && !isNaN(unixDate))
      result = ArmaDate.createFromUnixTime(unixDate).toDateTime('-', ':');
    return result;
  }
}

export interface ArmaSpy {
  Id: number;
  ObjectSpy: string;
  Action: string;
  ObjectID: number;
  ObjectCode: string;
  FileStr: string;
  FormatName: string;
  UnixDate: number; // A convertir en date avec ArmaDate
  ComputerName: string;
  WindowsUser: string;
  ArmaorUserId: number;
  ArmaorUserName: string;
  Comment: string;
}
